import { TFunction } from 'i18next';

import { GlobalApi } from '@Apis';
import { UpdateRecipientGroupReqDto } from '../../../../types/globalSetting';

export const onUpdateRecipientGroup = async (
  id: string,
  recipients: string,
  t: TFunction<'translation'>,
  groupName?: string
) => {
  const params: UpdateRecipientGroupReqDto = {
    emails: [],
  };
  if (groupName) {
    params.recipientGroupName = groupName;
  }
  params.emails = recipients.split(',').filter((item) => item !== '');
  try {
    const res = await GlobalApi.updateRecipientGroups(id, params);
    if (res.data?.id) {
      window.showNotification({
        titleMsg: t('globalSetting.recipientGroup.update.success'),
        severity: 'success',
      });
    }
  } catch (error: any) {
    const code = error?.status || 'Unknown';
    if (code === 400) {
      window.showNotification({
        titleMsg: t('common.error.invalidFormat'),
        severity: 'error',
      });
    } else {
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    }
  }
};
